var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbubbleSlash = function SvgChatbubbleSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.44c0-.95.21-1.85.58-2.7l11.93 10.44a12.366 12.366 0 0 1-5.19-.03 1.03 1.03 0 0 0-.71.09l-5.16 2.7a.5.5 0 0 1-.72-.55l1.06-4.75c.07-.32-.02-.65-.22-.9C.58 11.5 0 10.02 0 8.44Zm20 0c0 1.74-.7 3.36-1.88 4.67L4.91 1.56C6.4.85 8.14.45 10 .45c5.52 0 10 3.58 10 8ZM1.25 2.34c.36-.42 1-.46 1.41-.09l16 14c.42.36.46 1 .09 1.41-.36.42-1 .46-1.41.09l-16-14c-.42-.36-.46-1-.09-1.41Z"
  })));
};
export default SvgChatbubbleSlash;